import { createActions } from "redux-actions";

export const constants = {
  GET_SCHEDULE: "GET_SCHEDULE",
  CREATE_SCHEDULE_ITEM: "CREATE_SCHEDULE_ITEM",
  CREATE_SHIFT_ASSIGNMENT: "CREATE_SHIFT_ASSIGNMENT",
  REMOVE_SCHEDULE_ITEM: "REMOVE_SCHEDULE_ITEM",
};

export const actions = createActions({
  GET_SCHEDULE: {
    REQUEST: ({ date }) => ({ date }),
    SUCCESS: (result) => result,
    FAILURE: (result) => result,
  },
  CREATE_SCHEDULE_ITEM: {
    REQUEST: ({
      effectiveDate,
      expiryDate,
      shiftNumber,
      date,
      callTakerId = null,
    }) => ({ effectiveDate, expiryDate, shiftNumber, date, callTakerId }),
    SUCCESS: (result) => result,
    FAILURE: (result) => result,
  },
  CREATE_SHIFT_ASSIGNMENT: {
    REQUEST: ({
      effectiveDatetime,
      expiryDatetime,
      shiftNumber,
      callTakerId,
      bookingType,
    }) => ({
      effectiveDatetime,
      expiryDatetime,
      shiftNumber,
      callTakerId,
      bookingType,
    }),
    SUCCESS: (result) => result,
    FAILURE: (result) => result,
  },
  REMOVE_SCHEDULE_ITEM: {
    REQUEST: ({ id, callTakerId, date }) => ({ id, callTakerId, date }),
    SUCCESS: (result) => result,
    FAILURE: (result) => result,
  },
});
